<template>
  <template v-if="underMaintenance">
    <Maintenance
      :title="maintenanceTitle"
      :message="maintenanceMessage"
      :icon="maintenanceIcon"
    />
  </template>
  <template v-else>
    <div class="main--container">
      <div v-if="this.$store.getters.isAuthenticated === true">
        <Navigation />
        <CurrencySelector v-show="currencySelectorState" />
        <PolicySelector v-show="policySelectorState" />
      </div>
      <router-view />
    </div>
  </template>
</template>

<script>
import Maintenance from "@/views/00_Maintenance.vue";
import Navigation from "@/components/navigation/Navigation";
import CurrencySelector from "@/components/currencyselector/CurrencySelector";
import PolicySelector from "@/components/policyselector/PolicySelector";
export default {
  components: { Maintenance, Navigation, CurrencySelector, PolicySelector },

  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "NOTIFICATION") {
        if (mutation.payload && mutation.payload.text) {
          this.$wkToast(mutation.payload.text, {
            className: mutation.payload.class,
          });
        }
      }
    });
    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },

  data() {
    return {
      maintenanceTitle: "Under Construction",
      maintenanceMessage:
        "The mobile site for Carrick Concierge is currently under development and is coming soon, we thank you for your patience.",
      maintenanceIcon: "wrench",
      // maintenance variables
      screenWidth: window.innerWidth,
    };
  },

  computed: {
    underMaintenance() {
      // Enter the maintenance conditions here and return a boolean
      if (this.screenWidth < 650) {
        return true;
      }
      return false;
    },

    currencySelectorState() {
      return this.$store.getters.currencySelectorState;
    },

    policySelectorState() {
      return this.$store.getters.policySelectorState;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/base.scss";
</style>
